import { Component, Input, OnInit } from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { BulkImportService, ErrorRowInterface } from './bulk-import.service';
import { fieldOptions } from './header-mapping.options';

@Component({
  selector: 'app-bulk-import-mapper',
  templateUrl: './bulk-import-mapper.component.html',
  styleUrls: ['./bulk-import-mapper.component.scss'],
  standalone: false,
})
export class BulkImportMapperComponent implements OnInit {
  readonly displayedColumns = ['header-row', 'first-row', 'mapping'];
  readonly options = fieldOptions;
  @Input() pageStepper: MatStepper;

  subscriptions: Subscription[] = [];
  show = 10;
  proceedWithErrors = false;
  uploading$: Observable<boolean>;
  dataSource: any;
  errorMessage$: any;
  errors$: Observable<ErrorRowInterface[]>;

  constructor(private bulkImportService: BulkImportService) {}
  ngOnInit(): void {
    this.uploading$ = this.bulkImportService.uploading$;
    this.dataSource = this.bulkImportService.dataSource;
    this.errorMessage$ = this.bulkImportService.errorMessage$$.asObservable();
    this.errors$ = this.bulkImportService.errors$.pipe(
      map((errors) => {
        return errors.map((err) => {
          if (!this.isString(err.column)) {
            err.column = err.column.length > 1 ? err.column[0] + ' - ' + err.column[err.column.length - 1] : err.column;
          }
          return err;
        });
      }),
    );
  }

  uploadFileAndMapping(): void {
    this.bulkImportService.uploadFileAndMapping(this.pageStepper, this.proceedWithErrors);
  }
  increaseShow(): void {
    this.show += 10;
  }
  isString(val: any): boolean {
    return typeof val === 'string';
  }
}
